<template>
  <div>
    <b-modal :active="isTranslationsModalVisible" :can-cancel="true" @close="closeTranslationsModal">
      <div class="has-background-white-ter p-4">
        <h3 class="is-size-5 has-text-weight-semibold mb-4">
          {{ descriptionForm.id ? "Редактировать перевод" : "Добавить перевод" }}
        </h3>

        <form @submit.prevent="saveDescription">
          <div class="columns is-multiline">
            <div class="column is-one-quarter">
              <b-field
                label="Язык"
                :type="descriptionErrors.lang_code ? 'is-danger' : ''"
                :message="descriptionErrors.lang_code && descriptionErrors.lang_code[0] || ''"
              >
                <b-select v-model="descriptionForm.lang_code" expanded>
                  <option v-for="lang in supportedLangs" :key="lang" :value="lang">{{ lang }}</option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-three-quarters">
              <b-field
                label="Название"
                :type="descriptionErrors.name ? 'is-danger' : ''"
                :message="descriptionErrors.name && descriptionErrors.name[0] || ''"
              >
                <b-input v-model="descriptionForm.name" maxlength="255" />
              </b-field>
            </div>
            <div class="column is-full">
              <b-field
                label="Описание"
                :type="descriptionErrors.description ? 'is-danger' : ''"
                :message="descriptionErrors.description && descriptionErrors.description[0] || ''"
              >
                <b-input v-model="descriptionForm.description" type="textarea" />
              </b-field>
            </div>
            <div class="column is-full is-flex is-justify-content-end">
              <b-button class="mr-2" :disabled="isDescriptionSaving" @click="closeTranslationsModal">Отмена</b-button>
              <b-button type="is-info" native-type="submit" :loading="isDescriptionSaving">
                {{ descriptionForm.id ? "Сохранить" : "Добавить" }}
              </b-button>
            </div>
          </div>
        </form>
      </div>
    </b-modal>

    <b-tabs v-model="activeTab" type="is-boxed">
      <b-tab-item label="Компания">
        <div class="is-flex is-justify-content-space-between">
          <div class="has-background-white px-4 py-4 main-inner-set mr-4">
            <div class="mb-5">
              <p class="is-uppercase heading-text-size has-text-grey has-text-weight-medium mb-3">Редактировать Компанию</p>
              <small>Введите данные</small>
            </div>

            <b-field
              label="Тип"
              class="mt-3"
            >
              <b-select
                placeholder="Выберите компанию"
                :value="companyType"
                v-model="companyType"
              >
                <option
                  v-for="(n,idx) in Data_type"
                  :value="n"
                  :key="idx"
                >
                  {{ n }}
                </option>
              </b-select>
            </b-field>

            <label>
              <b><small>Наименование</small></b>
            </label>
            <input
              class="input mb-2"
              v-model="CompanyData.name"
              type="text"
              placeholder="Название компании"
            >
            <label>
              <b><small>БИН</small></b>
            </label>
            <input
              class="input mb-2"
              v-model="CompanyData.bin"
              type="text"
              placeholder="Бин компании"
            >
            <div class="mt-5">
              <button
                class="button is-info"
                @click="SaveChangesCom"
              >Сохранить
              </button>
              <button class="button is-warning mx-3">Деактивировать</button>
              <button
                class="button is-danger"
                @click="DeleteCompany"
              >Удалить
              </button>
            </div>
          </div>

          <div class="has-background-white px-4 py-4 main-inner-set">
            <h4 class="heading is-size-6 has-text-weight-medium">список филиалов</h4>
            <ul
              class="list"
              v-for="item of BranchesData"
              :key="item.id"
            >
              <li class="ml-3">
                <a @click="EditBranche(item.id)">{{ item.name }}</a>
              </li>
            </ul>
            <router-link
              class="has-text-weight-medium"
              to="/filials-registration"
            >Зарегистрировать филиал
            </router-link>
          </div>
        </div>
      </b-tab-item>

      <b-tab-item label="Переводы">
        <div class="has-background-white px-4 py-4">
          <div class="is-flex is-justify-content-space-between is-align-items-center mb-4">
            <h4 class="is-size-6 has-text-weight-medium">Переводы компании</h4>
            <b-button type="is-info" @click="openCreateDescriptionModal">Добавить</b-button>
          </div>

          <b-table
            :data="descriptions"
            :loading="isTranslationsLoading"
            hoverable
            striped
            @cellclick="openEditDescriptionModal"
          >
            <b-table-column field="id" label="ID" width="40" numeric v-slot="props">
              {{ props.row.id }}
            </b-table-column>
            <b-table-column field="lang_code" label="Язык" v-slot="props">
              {{ props.row.lang_code }}
            </b-table-column>
            <b-table-column field="name" label="Название" v-slot="props">
              {{ props.row.name || '-' }}
            </b-table-column>
            <b-table-column field="description" label="Описание" v-slot="props">
              {{ props.row.description || '-' }}
            </b-table-column>
            <b-table-column label="Удалить" centered v-slot="props">
              <b-button
                type="is-danger is-light"
                size="is-small"
                icon-right="trash"
                @click.stop="deleteDescription(props.row.id)"
              />
            </b-table-column>
          </b-table>

          <section v-if="descriptionsTotal > descriptionsPerPage" class="mt-4">
            <b-pagination
              :total="descriptionsTotal"
              :per-page="descriptionsPerPage"
              order="is-centered"
              icon-pack="fas"
              :current="descriptionsPage"
              class="base-table__pagination"
              @change="fetchDescriptions"
            />
          </section>
        </div>
      </b-tab-item>
    </b-tabs>
  </div>
</template>


<script>
export default {
  data() {
    return {
      CompanyData: [],
      company_id: null,
      companyType: null,
      BranchesData: [],
      Data_type: [],
      activeTab: 0,
      isTranslationsModalVisible: false,
      isTranslationsLoading: false,
      isDescriptionSaving: false,
      descriptions: [],
      descriptionsTotal: 0,
      descriptionsPage: 1,
      descriptionsPerPage: 10,
      supportedLangs: ["ru", "kk", "en"],
      descriptionForm: {
        id: null,
        lang_code: "ru",
        name: "",
        description: "",
      },
      descriptionErrors: {},
    };
  },
  watch: {
    activeTab(val) {
      if (val === 1) this.fetchDescriptions(this.descriptionsPage);
    },
  },
  created() {
    this.company_id = this.$router.history.current.params.id.replace(/[^0-9]/g, "");
    this.getCompanyData();
    this.GetCompanyBranches();
    this.GetDataToCreate();
  },
  methods: {
    async getCompanyData() {
      await this.$axios.get(`admin/companies/${this.company_id}`).then(response => {
        this.CompanyData = response.data.data;

        this.companyType = this.CompanyData.type;
      });
    },
    async DeleteCompany() {
      await this.$axios.delete(`admin/companies/${this.company_id}`).then(() => {
        this.$router.push("/company-list");
      });
    },
    async SaveChangesCom() {
      let data = {
        "name": this.CompanyData.name,
        "bin": this.CompanyData.bin,
        "type": this.companyType,
      };

      await this.$axios.put(`admin/companies/${this.company_id}`, data).then(response => {
        if (response.data.code == 201) {
          this.$router.push("/company-list");
        }
      });
    },
    async GetCompanyBranches() {
      await this.$axios.get(`admin/companies/${this.company_id}/branches`).then(response => {
        this.BranchesData = response.data.data;
      });
    },
    EditBranche(e) {
      this.$router.push(`/filial-editor/${e}`);
    },
    async GetDataToCreate() {
      await this.$axios.get(`admin/companies/create`).then(response => {
        this.Data_type = response.data.data.types;
      });
    },
    openCreateDescriptionModal() {
      this.resetDescriptionForm();
      this.isTranslationsModalVisible = true;
    },
    closeTranslationsModal() {
      this.isTranslationsModalVisible = false;
      this.resetDescriptionForm();
    },
    resetDescriptionForm() {
      this.descriptionErrors = {};
      this.descriptionForm = {
        id: null,
        lang_code: "ru",
        name: "",
        description: "",
      };
    },
    openEditDescriptionModal(item) {
      this.descriptionErrors = {};
      this.descriptionForm = {
        id: item.id,
        lang_code: item.lang_code || "ru",
        name: item.name || "",
        description: item.description || "",
      };
      this.isTranslationsModalVisible = true;
    },
    async fetchDescriptions(page = 1) {
      this.descriptionsPage = page || 1;
      this.isTranslationsLoading = true;
      const offset = (this.descriptionsPage - 1) * this.descriptionsPerPage;
      try {
        const { data } = await this.$axios.get(
          `admin/company-descriptions?company_id=${this.company_id}`
        );
        this.descriptions = data?.data || [];
        this.descriptionsTotal = data?.count || 0;
      } catch (e) {
        throw new Error(e);
      } finally {
        this.isTranslationsLoading = false;
      }
    },
    async saveDescription() {
      this.descriptionErrors = {};
      this.isDescriptionSaving = true;
      const payload = {
        company_id: this.company_id,
        lang_code: this.descriptionForm.lang_code,
        name: this.descriptionForm.name || null,
        description: this.descriptionForm.description || null,
        type: this.companyType || null,
      };

      try {
        if (this.descriptionForm.id) {
          await this.$axios.put(`admin/company-descriptions/${this.descriptionForm.id}`, payload);
        } else {
          await this.$axios.post("admin/company-descriptions", payload);
        }
        await this.fetchDescriptions(this.descriptionsPage);
        this.resetDescriptionForm();
      } catch (e) {
        this.descriptionErrors = e.error?.response?.data?.errors ?? {};
        throw e;
      } finally {
        this.isDescriptionSaving = false;
      }
    },
    async deleteDescription(id) {
      await this.$axios.delete(`admin/company-descriptions/${id}`);
      await this.fetchDescriptions(this.descriptionsPage);
      if (this.descriptionForm.id === id) this.resetDescriptionForm();
    },
  },
};
</script>

<style>
.main-inner-set {
  flex: 1;
}

.list {
  list-style: disc;
}

.heading-text-size {
  font-size: 14px;
}
</style>
